import React from 'react';
import type { DispensedQuantityProps } from '../../types';
import {
  getStrokeColor,
  getFillColor,
  getLeftAmount,
  calculatePercentage
} from '../../utils/dispensationHelpers';
import * as Styles from './QuantityStyles';

const DispensedQuantity: React.FC<DispensedQuantityProps> = ({
  dispensedAmount,
  prescribedAmount,
  availableQuantity,
  unit,
}) => {
  const percentage = calculatePercentage(dispensedAmount, prescribedAmount);
  const strokeColor = getStrokeColor(percentage);
  const fillColor = getFillColor(percentage);

  // Calcular preenchimento do círculo
  const radius = 9;
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset =
    circumference - (Math.min(percentage, 100) / 100) * circumference;

  const isCompleted = percentage >= 100;
  const leftAmountText = getLeftAmount(availableQuantity);

  return (
    <Styles.DispensedQuantityContainer>
      <Styles.DispensedQuantityRowWrapper>
        <Styles.DispensedQuantityCircleWrapper>
          <Styles.DispensedQuantityCircleContent>
            <Styles.DispensedQuantitySvg viewBox='0 0 24 24'>
              <circle
                cx='12'
                cy='12'
                r='9'
                fill={fillColor}
                stroke='#e5e7eb'
                strokeWidth='3'
              />
              {percentage > 0 && (
                <circle
                  cx='12'
                  cy='12'
                  r='9'
                  fill='none'
                  stroke={strokeColor}
                  strokeWidth='3'
                  strokeLinecap='round'
                  strokeDasharray={circumference}
                  strokeDashoffset={strokeDashoffset}
                  transform='rotate(-90 12 12)'
                />
              )}
            </Styles.DispensedQuantitySvg>
            <Styles.DispensedQuantityText>
              {dispensedAmount}
            </Styles.DispensedQuantityText>
          </Styles.DispensedQuantityCircleContent>
        </Styles.DispensedQuantityCircleWrapper>
        {isCompleted && <Styles.CheckIcon>✓</Styles.CheckIcon>}
      </Styles.DispensedQuantityRowWrapper>
      <Styles.DispensedQuantityUnit>{unit}</Styles.DispensedQuantityUnit>
      <Styles.DispensedQuantityLeftAmount>
        {leftAmountText}
      </Styles.DispensedQuantityLeftAmount>
    </Styles.DispensedQuantityContainer>
  );
};

export default DispensedQuantity;